// extracted by mini-css-extract-plugin
export default {"listStyle":"_2zWCagVI2-nOo1uFuBWXgA"};